import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Main from "./components/Main/Main";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
    return (
        <>
            <Router basename={process.env.REACT_APP_CLIENT_URL_DEV}>
                <Main />
            </Router>
        </>
    );
}

export default App;
